import {
  DropdownProps,
  Grid,
  Input,
  Loader,
  Ref,
  Select,
} from "semantic-ui-react";
import useNetwork from "./useNetwork";
import { useRef } from "react";

type NetworkProps = {
  region: string;
  selectedNetwork: string;
  errorClassName: string;
  onChange: (event: React.FormEvent<HTMLElement>, data: DropdownProps) => void;
};

const Title = () => (
  <Grid.Column textAlign="left" width={8} className="flex vcenter">
    <h5>Network</h5>
  </Grid.Column>
);

const Network = ({
  region,
  selectedNetwork,
  errorClassName,
  onChange,
}: NetworkProps) => {
  const networkRef = useRef(null);

  const { options, loading } = useNetwork(region);

  if (options.length) {
    return (
      <Ref innerRef={networkRef}>
        <Grid.Row className="separator">
          <Title />
          <Grid.Column textAlign="left" width={8} className="flex vcenter ">
            <Select
              icon="chevron circle down"
              value={selectedNetwork}
              name="selectedNetwork"
              options={options}
              className={`select-box full ${errorClassName}`}
              placeholder="Select Network"
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Ref>
    );
  }

  if (loading) {
    return (
      <Grid.Row className="separator">
        <Title />
        <Grid.Column textAlign="left" width={8} className="flex vcenter ">
          <div className="loader-wrapper">
            <Loader size="mini" active className="one-liner ">
              Fetching Network list...
            </Loader>
          </div>
        </Grid.Column>
      </Grid.Row>
    );
  }

  return (
    <Ref innerRef={networkRef}>
      <Grid.Row className="separator">
        <Title />
        <Grid.Column textAlign="left" width={8} className="flex vcenter ">
          <Input value="No networks found!" />
        </Grid.Column>
      </Grid.Row>
    </Ref>
  );
};
export default Network;
